// extracted by mini-css-extract-plugin
export default {"container":"Portfolio_container__k0eu1","partners":"Portfolio_partners__aPHr8","partnerContainer":"Portfolio_partnerContainer__2022B"};